module.exports = __webpack_public_path__ + "static/flags/CA-3f95bfdb19a39f142d793b66f587b8f7.gif";